/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Access_BlurbInputs */



/**
* | output |
* | --- |
* | "Space settings control who can see and edit this space. Grant access to whole teams or to individual users, and set their permissions here." |
*
* @param {Uno_Edu_Space_Access_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_access_blurb = /** @type {((inputs?: Uno_Edu_Space_Access_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Access_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Space-Einstellungen steuern, wer diesen Space sehen und bearbeiten kann. Gewähren Sie ganzen Teams oder einzelnen Benutzern Zugriff und legen Sie hier ihre Berechtigungen fest.")
	return /** @type {LocalizedString} */ ("Space settings control who can see and edit this space. Grant access to whole teams or to individual users, and set their permissions here.")
});